/* ET - Footer
   Three independent behaviours, all optional — the section renders and works with this file absent:

     1. Country / language selector disclosure.
     2. Collapsible nav columns on mobile (off by default; the Figma shows the columns expanded).
     3. Klaviyo newsletter submit (only when a list id is filled in; the default is Shopify's own
        {% form 'customer' %}, which needs no JavaScript at all).

   The selectors deliberately do NOT use Impact's <x-popover>: theme.js re-parents one to <body> below
   1000px, which would move the panel out of the subtree carrying every --et-ft-* custom property and
   leave it painting with no background at all. See snippets/et-footer-locale.liquid.

   Everything is re-initialised on shopify:section:load. Shopify replaces section markup with
   innerHTML, and a <script src> inserted that way never executes, so that event is the only hook
   that runs in the theme editor. */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var INIT_FLAG = 'etFooterReady';

  /* ----------------------------------------------------------------------------------------------
     Country / language selectors
     ---------------------------------------------------------------------------------------------- */

  function closeSelect(select) {
    var trigger = select.querySelector('[data-et-footer-select-trigger]');
    var panel = select.querySelector('[data-et-footer-select-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  function closeAllSelects(root, except) {
    var selects = root.querySelectorAll('[data-et-footer-select]');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i] !== except) closeSelect(selects[i]);
    }
  }

  function initSelects(root) {
    var selects = root.querySelectorAll('[data-et-footer-select]');
    if (!selects.length) return;

    for (var i = 0; i < selects.length; i++) {
      (function (select) {
        var trigger = select.querySelector('[data-et-footer-select-trigger]');
        var panel = select.querySelector('[data-et-footer-select-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            closeSelect(select);
            return;
          }

          /* Only one panel at a time: the country and language pills sit 16px apart and their panels
             both open upward, so two open at once would overlap each other. */
          closeAllSelects(root, select);
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;

          var current = panel.querySelector('[aria-current="true"]') || panel.querySelector('button');
          if (current) current.focus();
        });

        /* focusout rather than blur: blur does not bubble, so it would never fire for the option
           buttons inside the panel. relatedTarget is null when focus leaves the document entirely
           (tab away from the window), which must NOT close the panel — otherwise coming back would
           find it shut. */
        select.addEventListener('focusout', function (event) {
          var next = event.relatedTarget;
          if (!next) return;
          if (!select.contains(next)) closeSelect(select);
        });

        select.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape' && event.key !== 'Esc') return;
          if (trigger.getAttribute('aria-expanded') !== 'true') return;

          event.stopPropagation();
          closeSelect(select);
          trigger.focus();
        });
      })(selects[i]);
    }

  }

  /* Attached to the document exactly ONCE for the page, not once per section. Registering it inside
     initSelects would add a fresh listener on every shopify:section:load in the theme editor, each one
     holding a closure over a detached section element. Resolving the open panels from the live DOM at
     event time means this one listener covers every footer instance, present and future.

     pointerdown, not click: a click on an option submits the form and navigates, so a click handler
     racing that would be pointless. Pointerdown outside is the real dismiss gesture. */
  var documentListenerBound = false;

  function bindDocumentDismiss() {
    if (documentListenerBound) return;
    documentListenerBound = true;

    document.addEventListener('pointerdown', function (event) {
      var target = event.target;
      /* event.target can be a text node or the document itself, neither of which has closest(). */
      if (target && target.nodeType === 3) target = target.parentElement;
      var inside = target && target.closest ? target.closest('[data-et-footer-select]') : null;

      var open = document.querySelectorAll('[data-et-footer-select] [data-et-footer-select-trigger][aria-expanded="true"]');
      for (var i = 0; i < open.length; i++) {
        var select = open[i].closest('[data-et-footer-select]');
        if (select && select !== inside) closeSelect(select);
      }
    });
  }

  /* ----------------------------------------------------------------------------------------------
     Collapsible nav columns (mobile only, opt-in)
     ---------------------------------------------------------------------------------------------- */

  function initColumns(root, teardown) {
    var footers = root.querySelectorAll('.et-footer--collapsible');
    if (!footers.length) return;

    var mql = window.matchMedia(MOBILE_QUERY);

    for (var i = 0; i < footers.length; i++) {
      (function (footer) {
        var toggles = footer.querySelectorAll('[data-et-footer-col-toggle]');
        if (!toggles.length) return;

        /* The stylesheet only collapses under .is-js. Until this line runs — and for ever, if the
           script never loads — every panel stays open, so the links are always reachable. */
        footer.classList.add('is-js');

        function syncToBreakpoint() {
          var isMobile = mql.matches;

          for (var j = 0; j < toggles.length; j++) {
            var toggle = toggles[j];
            var column = toggle.closest('.et-footer__col');

            if (isMobile) {
              toggle.disabled = false;
              toggle.setAttribute('aria-expanded', column && column.classList.contains('is-open') ? 'true' : 'false');
            } else {
              /* Above the breakpoint the panel is always open and the heading is decoration. Dropping
                 aria-expanded stops it announcing a state that no longer exists, and disabled takes
                 the dead control out of the tab order rather than leaving a button that does nothing. */
              toggle.disabled = true;
              toggle.removeAttribute('aria-expanded');
            }
          }
        }

        for (var k = 0; k < toggles.length; k++) {
          toggles[k].addEventListener('click', function () {
            if (!mql.matches) return;

            var column = this.closest('.et-footer__col');
            if (!column) return;

            var willOpen = !column.classList.contains('is-open');
            column.classList.toggle('is-open', willOpen);
            this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          });
        }

        syncToBreakpoint();

        if (typeof mql.addEventListener === 'function') {
          mql.addEventListener('change', syncToBreakpoint);
          teardown.push(function () { mql.removeEventListener('change', syncToBreakpoint); });
        } else if (typeof mql.addListener === 'function') {
          /* Safari < 14 */
          mql.addListener(syncToBreakpoint);
          teardown.push(function () { mql.removeListener(syncToBreakpoint); });
        }
      })(footers[i]);
    }
  }

  /* ----------------------------------------------------------------------------------------------
     Klaviyo newsletter submit

     Only reached when the merchant picks Klaviyo AND fills in a list id; otherwise the form is
     Shopify's own {% form 'customer' %} and never touches this code. Klaviyo's public list-subscribe
     endpoint expects urlencoded fields and answers with { success: bool, errors: [] }.
     ---------------------------------------------------------------------------------------------- */

  var KLAVIYO_ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function showMessage(form, text, isError) {
    var node = form.querySelector('[data-et-footer-nl-message]');
    if (!node) return;

    node.textContent = text;
    node.hidden = false;
    node.classList.toggle('et-footer__nl-message--error', !!isError);
    node.classList.toggle('et-footer__nl-message--success', !isError);
  }

  function initKlaviyo(root) {
    /* The CONFIG lives on the field, not the form: the form is always Shopify's own
       {% form 'customer' %} so that a blocked or failed script still subscribes the visitor natively
       instead of POSTing the page to itself. This handler is the enhancement, not the mechanism. */
    var fields = root.querySelectorAll('[data-et-footer-klaviyo]');

    for (var i = 0; i < fields.length; i++) {
      (function (field) {
        var form = field.closest('form');
        if (!form) return;

        var listId = field.getAttribute('data-et-footer-klaviyo');
        /* Comes from the block's own settings so they follow Translate & Adapt like every other
           string in the section. Hardcoding them would print Dutch on the en and fr storefronts. */
        var fallbackError = field.getAttribute('data-et-footer-error') || 'Er ging iets mis.';
        var successText = field.getAttribute('data-et-footer-success') || 'Bedankt!';
        var input = form.querySelector('.et-footer__nl-input');
        var submit = form.querySelector('.et-footer__nl-submit');
        if (!listId || !input) return;

        form.addEventListener('submit', function (event) {
          /* Only take over once we know we can: if the address is invalid, let the browser's own
             validation speak rather than silently swallowing the submit. */
          if (!input.checkValidity()) return;

          event.preventDefault();

          if (submit) submit.disabled = true;

          var body = new URLSearchParams();
          body.append('g', listId);
          body.append('email', input.value);
          body.append('$fields', '$source');
          body.append('$source', 'footer');

          fetch(KLAVIYO_ENDPOINT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Accept: 'application/json'
            },
            body: body.toString()
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (data && data.success) {
                showMessage(form, successText, false);
                input.value = '';
              } else {
                var message = data && data.errors && data.errors.length ? data.errors[0] : null;
                showMessage(form, message || fallbackError, true);
              }
            })
            .catch(function () {
              showMessage(form, fallbackError, true);
            })
            .then(function () {
              if (submit) submit.disabled = false;
            });
        });
      })(fields[i]);
    }
  }

  /* ---------------------------------------------------------------------------------------------- */

  /* Keyed by the section element. Shopify REPLACES that element on shopify:section:load, so the new
     one has no flag and re-initialises cleanly; the map is what lets the OLD one's media-query
     listener be released on shopify:section:unload instead of pinning a detached tree for the life
     of the editor session. */
  var teardowns = typeof WeakMap === 'function' ? new WeakMap() : null;

  function init(root) {
    if (!root || root[INIT_FLAG]) return;
    root[INIT_FLAG] = true;

    var teardown = [];
    if (teardowns) teardowns.set(root, teardown);

    bindDocumentDismiss();
    initSelects(root);
    initColumns(root, teardown);
    initKlaviyo(root);
  }

  function destroy(root) {
    if (!root || !teardowns) return;
    var teardown = teardowns.get(root);
    if (!teardown) return;
    for (var i = 0; i < teardown.length; i++) teardown[i]();
    teardowns.delete(root);
  }

  function initAll() {
    var sections = document.querySelectorAll('.shopify-section--et-footer');
    for (var i = 0; i < sections.length; i++) {
      init(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function sectionFrom(target) {
    if (!target || !target.classList) return null;
    if (target.classList.contains('shopify-section--et-footer')) return target;
    return target.querySelector ? target.querySelector('.shopify-section--et-footer') : null;
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = sectionFrom(event.target);
    if (section) init(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(sectionFrom(event.target));
  });

  /* Selecting a nav_column in the editor sidebar scrolls to it, but with the columns collapsed on
     mobile the merchant would be editing links inside a 0-height clipped panel and could not see the
     change. Open the selected column; the breakpoint guard keeps this inert on desktop, where the
     panels are always open anyway. */
  document.addEventListener('shopify:block:select', function (event) {
    var column = event.target && event.target.closest
      ? event.target.closest('.et-footer__col--collapsible')
      : null;
    if (!column) return;
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    column.classList.add('is-open');
    var toggle = column.querySelector('[data-et-footer-col-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  });
})();
